import { PropsWithChildren } from 'react'
import { SectionContainer } from '../containers/section-container'
import { IntroSvg } from '../../svgs/intro'
import { Header } from '@app/components/general/header'
import { useTranslation } from '@app/lib/hooks/useTranslation'

function MarketingIntroChecker({ children }: PropsWithChildren<any>) {
  const { t } = useTranslation()

  return (
    <SectionContainer>
      <div className='block md:flex place-items-center pb-0 gap-8'>
        <div className={'flex-[0_2_70%] pb-4'}>
          <Header>{t('website-accessibility-checker:header')}</Header>
          <h2 className='text-lg py-2 text-gray-800 dark:text-gray-100'>
            {t('website-accessibility-checker:header-details')}
          </h2>
          <div className='py-3'>{children}</div>
        </div>
        <IntroSvg />
      </div>
    </SectionContainer>
  )
}

export { MarketingIntroChecker }
